export default "__VITE_ASSET__722705dd__"